import { useLocation, useParams } from "react-router-dom";

export default function useLiteratureCurrentView() {
    const { familyNameId } = useParams();
    const { pathname } = useLocation();

    const isInLiteratureView = pathname.indexOf('/literature') >= 0;
    const isInDocumentListView = pathname === '/literature' || pathname === '/literature/';
    const isInDocumentView = pathname.toLowerCase().indexOf('/literature/view') >= 0;
    const isInVideoView = pathname.toLowerCase().indexOf('/literature/video') >= 0;

    const isInNoFamilyFaultList = pathname === '/literature/fault' || pathname === '/literature/fault/';
    const isInFamilyFaultList = pathname === `/literature/fault/${familyNameId}` || pathname === `/literature/fault/${familyNameId}/`;
    const isInFaultList = isInNoFamilyFaultList || isInFamilyFaultList;
    const isInFaultView = pathname.toLowerCase().indexOf('/literature/fault') >= 0 && !isInFaultList;

    const isInServiceLog = pathname.toLowerCase().indexOf('/literature/service') >= 0;

    const isInServiceLogView = pathname.toLowerCase().indexOf('/literature/service/log/') >= 0;
    const isInServiceLogAddEdit = pathname.toLowerCase().indexOf('/log') >= 50 && isInServiceLog;
    const isInServiceLogList = pathname.toLowerCase().indexOf('/literature/service/log') >= 0 && !isInServiceLogView && !isInServiceLogAddEdit;

    const isInEngineInfo = pathname.toLowerCase().indexOf('/literature/engine') >= 0;

    const isInMaintenanceCalculator = pathname.toLowerCase().indexOf('/literature/maintenance/calculator') >= 0;

    let menuTitle = 'Literature';
    if (isInFaultList || isInFaultView) {
        menuTitle = 'Fault Lookup';
    }
    else if (isInEngineInfo) {
        menuTitle = 'Engine Info';
    } else if (isInServiceLog) {
        menuTitle = 'Service Log';
    }
    else if (isInMaintenanceCalculator) {
        menuTitle = 'Maintenance Schedule and Rates';
    }

    let faultViewFamilyId = null;
    if (isInFaultView) {
        faultViewFamilyId = familyNameId;
    }

    return {
        isInLiteratureView, isInDocumentListView, isInDocumentView, isInVideoView,
        isInFaultView, faultViewFamilyId, isInFaultList,
        isInEngineInfo, menuTitle, isInServiceLog,
        isInServiceLogList, isInServiceLogView, isInServiceLogAddEdit,
        isInMaintenanceCalculator
    };
}